import classNames from "classnames"
import { useFullnameForUserId } from "features/data-management/users/storage"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { MapNodeIconState } from "plugins/plugin-registry"
import { useAppSelector } from "integrations/redux/hooks"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"

const MAX_FACES = 2

export const UserCommentBubble = ({
    userId,
    state,
    participantIds = [],
    isUnread = false,
}: {
    userId: string
    state?: MapNodeIconState
    participantIds?: string[]
    isUnread?: boolean
}) => {
    const { fullName } = useFullnameForUserId(userId)
    const members = useAppSelector(selectWorkspaceMembers)

    const isActive = state === "active"
    const repliers = participantIds.filter((participantId) => participantId !== userId)
    const faces = repliers.slice(0, MAX_FACES)
    const overflow = repliers.length - faces.length

    return (
        <div
            data-active={isActive}
            className={classNames(
                "flex items-center shrink-0 p-1",
                "rounded-[20px] rounded-bl-none",
                isUnread ? "bg-blue-500" : "bg-black-400",
                "ring-1 ring-transparent data-[active=true]:ring-blue-500",
                "backdrop-blur-[6px]",
                "origin-bottom-left transition-all duration-150 hover:scale-105 data-[active=true]:scale-105",
                !isActive &&
                    (isUnread
                        ? "hover:bg-blue-200 hover:shadow-[0px_2px_12px_0px_rgba(0,0,0,0.25)]"
                        : "hover:bg-black-500 hover:shadow-[0px_2px_12px_0px_rgba(0,0,0,0.25)]")
            )}
        >
            <div className="h-8 w-8 rounded-full overflow-hidden border border-black-600 z-[2] drop-shadow-[0px_1px_4px_rgba(0,0,0,0.35)]">
                <ProfilePhoto userId={userId} fullName={fullName || ""} />
            </div>
            {faces.map((participantId, index) => (
                <div
                    key={participantId}
                    style={{ zIndex: 1 - index }}
                    className="h-6 w-6 rounded-full overflow-hidden border border-black-600 -ml-1 drop-shadow-[0px_0.75px_3px_rgba(0,0,0,0.35)]"
                >
                    <ProfilePhoto
                        userId={participantId}
                        fullName={
                            members.find((member) => member.userId === participantId)?.fullName ??
                            ""
                        }
                    />
                </div>
            ))}
            {overflow > 0 && (
                <div
                    className={classNames(
                        "h-6 w-6 rounded-full border border-black-600 -ml-1 z-[-1]",
                        "flex items-center justify-center select-none",
                        "drop-shadow-[0px_0.75px_3px_rgba(0,0,0,0.35)]",
                        isUnread ? "bg-black-600" : isActive ? "bg-white-200" : "bg-gray-600"
                    )}
                >
                    <small className="text-white-700">{`+${overflow}`}</small>
                </div>
            )}
        </div>
    )
}
